import React from 'react'
import { Navigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import { useAuth } from '../Context/AuthContext'
import CustomLoader from '../Component/CustomLoader/customLoader'

const ProtectedRoute = ({ Component }) => {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <Box sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CustomLoader />
      </Box>
    )
  }

  return isAuthenticated ? <Component /> : <Navigate to="/" replace />
}

export default ProtectedRoute
